module.exports = __webpack_public_path__ + "img/mastercard-securecode-white.918197f8.png";